import React, { useState, useEffect } from 'react';
import { Download, Clock } from 'lucide-react';
import { Button } from './ui/button';
import { useNavigate } from 'react-router-dom';

const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.shraddha.spiritualai';

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [showStoreOptions, setShowStoreOptions] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      scrolled 
        ? 'bg-[#1a0f0f]/90 backdrop-blur-md shadow-lg border-b border-white/10' 
        : 'bg-transparent'
    }`}>
      <div className="container mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div 
            className="flex items-center gap-2 cursor-pointer"
            onClick={() => navigate('/')}
          >
            <div className="w-10 h-10 bg-gradient-to-r from-orange-500 to-yellow-500 rounded-xl flex items-center justify-center">
              <span className="text-white font-bold text-xl">श</span>
            </div>
            <h1 className="font-serif text-2xl font-bold text-gradient">
              ShraddhaAI
            </h1>
          </div>

          {/* CTA Button with Dropdown */}
          <div className="relative">
            <Button 
              onClick={() => window.open(PLAY_STORE_URL, '_blank', 'noopener,noreferrer')}
              className="bg-gradient-to-r from-orange-500 to-orange-600 hover:from-orange-600 hover:to-orange-700 text-white px-6 py-2 rounded-full glow-effect btn-primary"
            >
              <Download className="w-4 h-4 mr-2" />
              Download App
            </Button>

            {/* Store Options Dropdown */}
            {showStoreOptions && (
              <div className="absolute right-0 top-full mt-2 w-64 divine-card p-4 shadow-xl">
                <div className="space-y-3">
                  {/* Play Store */}
                  <a
                    href={PLAY_STORE_URL}
                    target="_blank"
                    rel="noreferrer"
                    className="flex items-center gap-3 p-3 rounded-lg bg-orange-500/10 border border-orange-500/20 hover:bg-orange-500/20 transition-colors"
                  >
                    <div className="w-10 h-10 bg-gradient-to-r from-orange-500 to-orange-600 rounded-lg flex items-center justify-center">
                      <Download className="w-5 h-5 text-white" />
                    </div>
                    <div className="flex-1 text-left">
                      <p className="text-white font-semibold text-sm">Play Store</p>
                      <p className="text-gray-400 text-xs">Available Now</p>
                    </div>
                  </a>

                  {/* App Store - Coming Soon */}
                  <div className="flex items-center gap-3 p-3 rounded-lg bg-gray-500/10 border border-gray-500/20 opacity-60 cursor-not-allowed">
                    <div className="w-10 h-10 bg-gray-600 rounded-lg flex items-center justify-center">
                      <Clock className="w-5 h-5 text-gray-400" />
                    </div>
                    <div className="flex-1 text-left">
                      <p className="text-gray-300 font-semibold text-sm">App Store</p>
                      <p className="text-gray-500 text-xs">Coming Soon</p>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Click outside to close dropdown */}
      {showStoreOptions && (
        <div 
          className="fixed inset-0 z-40" 
          onClick={() => setShowStoreOptions(false)}
        ></div>
      )}
    </header>
  );
};

export default Header;